interface UpdateItem {
  time: string;
  title: string;
  tag: string;
}

const updates: UpdateItem[] = [
  { time: '07-29 14:30', title: '知名导演新片发布会现场争议发言引发舆论热议，多方回应', tag: '最新' },
  { time: '07-29 12:15', title: '网红CP分手内幕曝光，双方粉丝阵营激烈对峙社交平台', tag: '热议' },
  { time: '07-29 09:42', title: '热门综艺录制花絮流出，未播片段揭示不为人知的幕后故事', tag: '独家' },
  { time: '07-28 22:08', title: '某品牌代言人突然解约，品牌方与艺人双方各执一词引关注', tag: '最新' },
  { time: '07-28 18:33', title: '社交媒体平台出现大量疑似明星小号，内容劲爆引发围观', tag: '热议' },
  { time: '07-28 15:20', title: '年度音乐颁奖礼提名名单公布，多位艺人意外落选引起讨论', tag: '最新' },
  { time: '07-28 10:55', title: '短视频平台热门挑战引发安全争议，官方紧急发布提醒公告', tag: '热议' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-2">最新动态</h2>
        <p className="text-foreground-500 text-sm text-center mb-10">全平台实时更新，最快掌握吃瓜前线动态</p>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
          <div className="flex flex-col gap-6">
            {updates.map((item, idx) => (
              <div key={idx} className="flex items-start gap-5">
                <div className="relative z-10 flex-shrink-0 w-[38px] h-[38px] rounded-full bg-primary-100 flex items-center justify-center border-2 border-background-50">
                  <div className="w-3 h-3 rounded-full bg-primary-500"></div>
                </div>
                <div className="flex-1 min-w-0 pt-1.5">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-400 font-medium">{item.time}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                      item.tag === '独家'
                        ? 'bg-accent-100 text-accent-700'
                        : item.tag === '热议'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-primary-100 text-primary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}